import { useEffect, useRef } from "react";
import { Bold, Italic, Heading, List, Link2, Image } from "lucide-react";

export default function RichEditor({ value, onChange, testid }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) ref.current.innerHTML = value || "";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const exec = (cmd, arg) => { document.execCommand(cmd, false, arg); ref.current?.focus(); onChange(ref.current.innerHTML); };
  const btn = (Icon, fn, label) => (
    <button type="button" onMouseDown={(e) => { e.preventDefault(); fn(); }} className="p-1.5 rounded hover:bg-slate-200 text-slate-600" title={label}><Icon className="w-4 h-4" /></button>
  );
  return (
    <div className="border border-slate-300 rounded-lg overflow-hidden">
      <div className="flex flex-wrap gap-1 p-1 border-b border-slate-200 bg-slate-50">
        {btn(Bold, () => exec("bold"), "Gras")}
        {btn(Italic, () => exec("italic"), "Italique")}
        {btn(Heading, () => exec("formatBlock", "H2"), "Titre")}
        {btn(List, () => exec("insertUnorderedList"), "Liste")}
        {btn(Link2, () => { const u = prompt("URL du lien :"); if (u) exec("createLink", u); }, "Lien")}
        {btn(Image, () => { const u = prompt("URL de l'image :"); if (u) exec("insertImage", u); }, "Image")}
      </div>
      <div ref={ref} contentEditable suppressContentEditableWarning className="p-3 min-h-[180px] max-h-[360px] overflow-y-auto text-sm outline-none prose prose-sm max-w-none" data-testid={testid} onInput={() => onChange(ref.current.innerHTML)} />
    </div>
  );
}
